export const baseHeaderAppName = 'Signal OnSite';
